import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import ExportTypeSelector from './export-type-selector';
import messages from '../messages';
import style from '../style.module.less';
import { EXPORT_ALL, CHOOSE_EXPORT_DIALOGUE, EXPORT_IN_PROGRESS_DIALOGUE } from '../../constants/export-products';
import { useProductContext } from '../../product-context';
import { exportProductsRequest } from '../../../../../store/products/grid/product.grid.actions';
import { useQuickSearchTerm } from '../../../../../hooks/routing/use-quick-search-term';
import ModalPortal from '../../../../../components/modal-portal';

const ExportModal = ({ onCloseModal }) => {
  const dispatch = useDispatch();
  const { totalRecords, selectedProductIds, appliedFilters } = useProductContext();
  const [modalDialogue, setModalDialogue] = useState(CHOOSE_EXPORT_DIALOGUE);
  const [exportType, setExportType] = useState(EXPORT_ALL);
  const productIds = exportType === EXPORT_ALL ? null : selectedProductIds;
  const searchTerm = useQuickSearchTerm() || '';
  const onConfirm = useCallback(() => {
    dispatch(exportProductsRequest(searchTerm, appliedFilters, productIds));
    setModalDialogue(EXPORT_IN_PROGRESS_DIALOGUE);
  }, [searchTerm, appliedFilters, productIds, dispatch]);

  return (
    <ModalPortal onClose={onCloseModal}>
      <Modal>
        <ModalHeader closeModal={onCloseModal}>
          <FormattedMessage {...messages.productExportModalTitle} />
        </ModalHeader>
        <ModalBody className={style['product-export-modal']}>
          {modalDialogue === CHOOSE_EXPORT_DIALOGUE && (
            <ExportTypeSelector
              exportType={exportType}
              selectedCount={selectedProductIds.length}
              setExportType={setExportType}
              totalRecords={totalRecords}
            />
          )}
          {modalDialogue === EXPORT_IN_PROGRESS_DIALOGUE && <FormattedMessage {...messages.productExportModalStarted} />}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onCloseModal} theme='tertiary'>
            <FormattedMessage {...messages.cancel} />
          </Button>
          {modalDialogue === CHOOSE_EXPORT_DIALOGUE && (
            <Button onClick={onConfirm} theme='primary'>
              <div>
                <FormattedMessage {...messages.exportButton} />
              </div>
            </Button>
          )}
          {modalDialogue === EXPORT_IN_PROGRESS_DIALOGUE && (
            <Button onClick={onCloseModal} theme='primary'>
              <FormattedMessage {...messages.close} />
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

ExportModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
};

export default ExportModal;
